import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UsuarioLoginResponse } from '../../../services/responses/platform/usuario-login.response';
import { AuthService } from '../../../services/apis/platform/auth.service';
import { PermissionsEnum } from '../../../services/enums/permissions.enum';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-action-nav',
  imports: [CommonModule,
    RouterModule,
    ReactiveFormsModule,],
  templateUrl: './action-nav.component.html',
  styleUrl: './action-nav.component.css',
})
export class ActionNavComponent implements OnInit {
  @Input() showActionNav: boolean;
  @Output() showActionNavFalse = new EventEmitter<number>();

  adminMenu = false;
  userMenu = false;
  salesMenu = false;
  finMenu = false;
  supplierMenu = false;
  reviewMenu = false;
  publicationMenu = false;
  editorMenu = false;

  public _usuarioLoginResponse: UsuarioLoginResponse;

  constructor(public authService: AuthService) { }

  ngOnInit(): void {
    this._usuarioLoginResponse = this.authService.getUserInfos();
    if (this._usuarioLoginResponse.listPermissions && this._usuarioLoginResponse.listPermissions.length > 0) {
      this._usuarioLoginResponse.listPermissions.forEach((permission) => {
        this.adminMenu = true;
        switch (permission) {
          case PermissionsEnum.Administrador:
            this.userMenu = true;
            this.reviewMenu = true;
            this.salesMenu = true;
            this.finMenu = true;
            this.supplierMenu = true;
            this.publicationMenu = true;
            this.editorMenu = true;
            break;
          case PermissionsEnum.Revisor:
            this.reviewMenu = true;
            break;
          case PermissionsEnum.Financeiro:
            this.finMenu = true;
            break;
          case PermissionsEnum.Vendas:
            this.salesMenu = true;
            break;
          case PermissionsEnum.Fornecedor:
            this.supplierMenu = true;
            break;
          case PermissionsEnum.Publicar:
            this.publicationMenu = true;
            break;
          case PermissionsEnum.Editor:
            this.editorMenu = true;
            break;
        }
      });
    }
  }

  clickContainerOut(): void {
    this.showActionNavFalse.emit();
  }
}
